export { default as NewSurveyPage } from './NewSurvey';
export { default as HomePage } from './Home';
export { default as TemplatesPage } from './Templates';
